import styled from 'styled-components';
import Typography from '@mui/material/Typography';

export const EmptyText = styled(Typography)``;
